import { Controller, useFormContext } from "react-hook-form";

import type { InputPhoneNumberProps } from "../index";
import { InputPhoneNumber } from "../index";

export type FormInputPhoneNumberProps = Omit<InputPhoneNumberProps, "value" | "onChange"> & {
  name?: string;
};

export const FormInputPhoneNumber = ({
  name = "phoneNumber",
  ...props
}: FormInputPhoneNumberProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <InputPhoneNumber
          {...props}
          value={field.value || ""}
          onChange={field.onChange}
          error={error?.message}
        />
      )}
    />
  );
};
